import { BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_MUTE_STATUSES } from 'actions/Types';
import {
  AGORA_ATTENDEE_MUTE_UNMUTE_CHANGE,
  MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGE
} from '@shoflo/studio-redux/constants/SocketEvents';
import { setAttendeeMuteStatus } from '@shoflo/studio-redux/actions';
import { muteLocalAudioStream } from '@cvent/studio-agora/audio/audioHelper';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';
import { StudioLogger } from '@studio/logger';

const LOG = new StudioLogger('toggleMultipleAgoraAttendeeMuteStatuses');

const toggleMultipleAgoraAttendeeMuteStatuses = muteStatuses => {
  return (dispatch, getState, socket) => {
    const { broadcast, meeting } = getState();
    const broadcastId = broadcast && broadcast._id;
    const localAttendeeId = meeting.attendeeId;
    const localAudioTrack = meeting?.client?.localTracks?.find(
      ({ trackMediaType }) => trackMediaType === 'audio'
    );

    const unassignedMuteStatuses = filterUnassignedSources(muteStatuses);

    const action = {
      type: BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_MUTE_STATUSES,
      request: async () => {
        for (const [attendeeId, isMuted] of Object.entries(muteStatuses)) {
          const payload = {
            attendeeId,
            isMuted,
            broadcastId
          };

          try {
            const isLocalUser = attendeeId === localAttendeeId;

            if (isLocalUser && localAudioTrack) {
              await muteLocalAudioStream(localAudioTrack, isMuted);
              dispatch(setAttendeeMuteStatus(attendeeId, isMuted));
            }

            socket.emit(AGORA_ATTENDEE_MUTE_UNMUTE_CHANGE, payload);

            if (attendeeId.includes(UNASSIGNED)) {
              dispatch(setAttendeeMuteStatus(attendeeId, isMuted));
            }
          } catch (error) {
            LOG.error(
              `Failed to toggle Agora attendee mute status for attendeeId: ${attendeeId}`,
              error
            );
            throw error;
          }
        }

        if (Object.keys(unassignedMuteStatuses).length > 0) {
          socket.emit(MULTIPLE_ATTENDEE_MIC_STATUSES_CHANGE, {
            muteStatuses: unassignedMuteStatuses,
            broadcastId
          });
        }

        return Object.create(null);
      },
      payload: unassignedMuteStatuses
    };

    dispatch(action);
  };
};

const filterUnassignedSources = muteStatuses =>
  Object.keys(muteStatuses)
    .filter(key => key.includes(UNASSIGNED))
    .reduce((acc, key) => {
      acc[key] = muteStatuses[key];
      return acc;
    }, {});

export default toggleMultipleAgoraAttendeeMuteStatuses;
